import { useState, useEffect } from "react";
import ConfigResult from "./ConfigResult/ConfigResult";
import { useApi } from "../apiHelpers";
import PageLayout from '../components/ui/PageLayout';
import { Panel } from '../components/ui/Panel';
import { EmptyState } from '../components/ui/EmptyState';

const Configurations = () => {
  const api = useApi();
  const [configs, setConfigs] = useState([]); // State for configurations

  // Fetch configurations from the database
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const fetchConfigs = async () => {
      try {
        const data = await api.get(`/configurations`, {
          errorAlert: "Configs could not be found."
        });
        setConfigs(data);
      } catch (error) {
        // Error alert already handled by api.get
      }
    };

    fetchConfigs();
  }, []);

  return (
    <PageLayout width="narrow" kind="workspace" className="pt-6">
<Panel title="Drone Configurations" className="text-white">
      <ol className="rectangle-list">
        {configs.length > 0 ? (
          configs.map((config) => (
            <ConfigResult
              key={config.id}
              id={config.id}
              title={config.title}
              className="p-4 hover:bg-surface-container-high transition"
            />
          ))
        ) : (
          <li><EmptyState variant="area">No configurations found.</EmptyState></li>
        )}
      </ol>
    </Panel>
</PageLayout>
  );
};

export default Configurations;
